"use client";

import { c as _c } from "react/compiler-runtime";
import { useActionState } from "react";
import { CheckCircle2, Loader2 } from "lucide-react";
import { requestAuthorChallengeEnrollment, type PromotionEnrollmentState } from "@/lib/actions/promotion-actions";
import { Button } from "@/components/ui/button";
import { FormError } from "@/components/ui/form-error";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
export function AuthorChallengeEnrollmentForm() {
  const $ = _c(22);
  const [state, formAction, isPending] = useActionState(requestAuthorChallengeEnrollment, null);
  if (state?.success) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="flex items-start gap-3 rounded-lg border border-primary/20 bg-primary/10 p-4 text-sm" role="status"><CheckCircle2 className="mt-0.5 size-5 shrink-0 text-primary" /><p>Request received. We'll email you to confirm your story and start date.</p></div>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden="true" className="absolute left-[-9999px] top-[-9999px] h-0 w-0 overflow-hidden"><label htmlFor="promotion-website">Website</label><input id="promotion-website" name="website" type="text" tabIndex={-1} autoComplete="off" /></div>;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Label htmlFor="promotion-story-title">Story title</Label>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isPending) {
    t2 = <div className="space-y-2">{t1}<Input id="promotion-story-title" name="storyTitle" maxLength={200} required={true} disabled={isPending} placeholder="The story you want to enroll" /></div>;
    $[3] = isPending;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Label htmlFor="promotion-email">Email</Label>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isPending) {
    t4 = <div className="space-y-2">{t3}<Input id="promotion-email" name="email" type="email" maxLength={254} required={true} disabled={isPending} autoComplete="email" placeholder="you@example.com" /></div>;
    $[6] = isPending;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = state?.error ?? null;
  let t6;
  if ($[8] !== t5) {
    t6 = <FormError message={t5} />;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== isPending) {
    t7 = isPending && <Loader2 className="animate-spin" />;
    $[10] = isPending;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = isPending ? "Sending\u2026" : "Request enrollment";
  let t9;
  if ($[12] !== isPending || $[13] !== t7 || $[14] !== t8) {
    t9 = <Button type="submit" className="w-full" disabled={isPending}>{t7}{t8}</Button>;
    $[12] = isPending;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <p className="text-center text-xs text-muted-foreground">Your 12 weeks start when we email you a confirmation.</p>;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t2 || $[18] !== t4 || $[19] !== t6 || $[20] !== t9) {
    t11 = <form action={formAction} className="space-y-4">{t0}{t2}{t4}{t6}{t9}{t10}</form>;
    $[17] = t2;
    $[18] = t4;
    $[19] = t6;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
}